import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { take } from 'rxjs/operators'
import { AuthFacade } from '../auth/auth.facade'
import { AuthService } from '../common/services/auth.service'
import { RoleEnum } from '../ui/constants/roles.constant'

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private readonly router: Router,
        private readonly auth: AuthFacade,
        private readonly authService: AuthService
    ) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        // RxJS 6: toPromise is fine here. After upgrading to RxJS 7+, use firstValueFrom(this.auth.getCurrentUserAccount()).
        const currentUser = await this.auth.getCurrentUserAccount().pipe(take(1)).toPromise()
        if (!currentUser) {
            return false
        }

        const configured = route.data['roles'] as string[] | undefined

        if (configured && currentUser.identityRoles?.length === 0) {
            await this.auth.signOut()
            return false
        }

        const allowedRoles = configured?.length ? configured : RoleEnum.ALL

        if (!this.authService.isAuthorizedForWithAccount(currentUser, allowedRoles)) {
            await this.router.navigate(['notauthorized'])
            return false
        }

        return true
    }
}
